/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({"data":{"categories":{"cardinal":["one","other"],"ordinal":["few","one","other","two"]},"fn":function(num, isOrdinal, exponent = 0) {
    const numStr = String(num);
    const parts = numStr.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1] || "";
    const n = Math.abs(parseFloat(numStr));
    const i = Math.floor(Math.abs(parseFloat(integerPart)));
    if (isOrdinal) {
        if (n === 4)
            return "few";
        if (n === 1)
            return "one";
        if ((n === 2 || n === 3))
            return "two";
    }
    else {
        if (i === 0 || n === 1)
            return "one";
    }
    return "other";
}},"locale":"kok-Latn"})
} else {
  (globalThis.__FORMATJS_PLURALRULES_DATA__ = globalThis.__FORMATJS_PLURALRULES_DATA__ || []).push({"data":{"categories":{"cardinal":["one","other"],"ordinal":["few","one","other","two"]},"fn":function(num, isOrdinal, exponent = 0) {
    const numStr = String(num);
    const parts = numStr.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1] || "";
    const n = Math.abs(parseFloat(numStr));
    const i = Math.floor(Math.abs(parseFloat(integerPart)));
    if (isOrdinal) {
        if (n === 4)
            return "few";
        if (n === 1)
            return "one";
        if ((n === 2 || n === 3))
            return "two";
    }
    else {
        if (i === 0 || n === 1)
            return "one";
    }
    return "other";
}},"locale":"kok-Latn"})
}
